<template>
  <div class="main_menu">
    <ul>
      <NavItem to="/" label="Home" />&nbsp;

      <NavItem to="/menu" label="Menu" />&nbsp;

      <NavItem to="/locations" label="Locations" />&nbsp;

      <!-- <NavItem to="/about" label="About Us" />&nbsp; -->

      <NavItem to="/contact" label="Contact Us" />&nbsp;

      <li class="gift-cards">
        <a href="https://app.yiftee.com/gifts/egift_and_gift_cards/jeffrey-s-hamburgers-menlo-park"
          target="jeffreys">
          <span>
            <img src="http://app.yiftee.com/assets/images/icons/egift_icon.png"
                height="18px"
                style="margin-right: 5px; margin-bottom: -3px;">
            Gift Cards
          </span>
        </a>
      </li>&nbsp;

      <li class="order">
        <a href="https://jeffreyshamburgers.alohaorderonline.com/">
          Order Online
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import NavItem from '@/components/NavItem.vue';

export default {
  name: 'TheMainNavigation',

  components: {
    NavItem,
  },
};
</script>
